
//# sourceMappingURL=slider.type.mjs.map
